<div class="property-info">
    <div class="info-left">
        <div class="info-title">{{ info.propertyName }}</div>

        <div class="info-location">
            {{ info.propertyAddress }}, {{ info.zoneName }}, {{ info.cityName }}
        </div>

        <div class="info-status">
            <span class="tag">{{ info.adLabel }}</span>
            <span class="tag muted">{{ info.optUseStatus }}</span>
        </div>
    </div>

    <div class="info-right">
        <div class="segment">
            <img [src]="info.segmentImagePath" alt="{{ info.segmentLabel }}" />
            <span>{{ info.segmentLabel }}</span>
        </div>
        <div class="price">{{ info.adPrice }}</div>
    </div>
</div>
